export const syncGatewayStoreTrackingCookies = (
  rtkfbp: string | undefined,
  rtkfbc: string | undefined,
  rtkttclid: string | undefined,
): void => {
  const gatewayStore = useKegelGatewayStore();

  if (rtkfbp) {
    gatewayStore.fbp = rtkfbp;
  }
  if (rtkfbc) {
    gatewayStore.fbc = rtkfbc;
  }
  if (rtkttclid) {
    gatewayStore.ttclid = rtkttclid;
  }
};
